import { useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { LogIn, UserPlus, ArrowLeft } from "lucide-react";

// Fleety Logo Component
const FleetyLogo = ({ className = "", size = "default" }) => {
  const sizeClasses = {
    small: "text-2xl",
    default: "text-4xl md:text-5xl",
    large: "text-5xl md:text-6xl"
  };
  
  return (
    <div className={`fleety-logo ${sizeClasses[size]} ${className}`} data-testid="fleety-logo">
      <span className="text-[#3FA9F5]">F</span>
      <span className="text-[#3FA9F5]">leety</span>
    </div>
  );
};

const AuthChoicePage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white flex flex-col" data-testid="auth-choice-page">
      {/* Top Spacer for mobile */}
      <div className="h-6 bg-[#3FA9F5]"></div>
      
      {/* Header */}
      <header className="bg-[#3FA9F5] p-6 flex items-center gap-4">
        <button 
          onClick={() => navigate("/")}
          className="text-white hover:text-white/80 transition-colors"
          data-testid="back-btn"
        >
          <ArrowLeft size={24} />
        </button>
        <FleetyLogo size="small" className="text-white [&>span]:text-white" />
      </header>

      {/* Main Content */}
      <main className="flex-1 flex flex-col items-center justify-center px-6">
        <div className="w-full max-w-md text-center">
          <h1 className="font-heading text-3xl font-bold text-gray-900 mb-2">
            Welcome to Fleety
          </h1>
          <p className="text-gray-500 mb-10">
            Choose how you'd like to continue
          </p>

          <div className="space-y-4">
            <Button 
              onClick={() => navigate("/login")}
              className="w-full h-14 bg-[#3FA9F5] hover:bg-[#2196F3] text-white text-lg font-semibold rounded-full shadow-fleety transition-all flex items-center justify-center gap-3"
              data-testid="login-btn"
            >
              <LogIn className="w-5 h-5" />
              Login
            </Button>

            <Button 
              onClick={() => navigate("/signup")}
              variant="outline"
              className="w-full h-14 border-2 border-[#3FA9F5] text-[#3FA9F5] hover:bg-[#3FA9F5] hover:text-white text-lg font-semibold rounded-full transition-all flex items-center justify-center gap-3"
              data-testid="signup-btn"
            >
              <UserPlus className="w-5 h-5" />
              Sign Up
            </Button>
          </div>
        </div>
      </main>
    </div>
  );
};

export default AuthChoicePage;
